<div [ngStyle]="{ width: (steps.length * 75) + 'px' }">
  @for (i of steps; track i) {
    <!--Add the step circle-->
		<div (click)="onClick(i)" [ngClass]="
		{
			'current': i === currentStep,
			'bg-green-light': i <= completedSteps && i !== currentStep,
			'bg-gray-light': i > completedSteps,
			'can-click': hasClickEvent
		}"
      class='rounded-circle step'>
      <span class='stepNumber'>{{ i }}</span>
    </div>
  }
</div>
